// CollabToolsPage — 협업도구(칸반·협업테이블·위키) 선택 랜딩 + NC iframe 임베드.
import AppShell from '../components/AppShell';
import Announcements from '../components/Announcements';
import { Page, PageHeader, Pill } from '../components/ui';
import { COLLAB_TOOLS } from '../constants/collabTools';
import { IconBook2, IconClipboardList, IconLayoutKanban, IconNotes, IconPuzzle, IconTable } from '@tabler/icons-react';
import { card as cardBase, ICON_STROKE } from '../utils/uiStyles';

const TOOL_ICONS = {
  deck: IconLayoutKanban,
  tables: IconTable,
  collectives: IconBook2,
  forms: IconClipboardList,
  notes: IconNotes,
};

// 협업 도구 — 칸반/협업테이블/위키 런처. 각 도구는 새 창으로 게이트웨이 임베드 뷰(/collab-view/:key)를 연다
// → 새 창이라도 NC 상단 헤더 잡메뉴 정리가 적용됨(2026-06-19 마스터 지시).
export default function CollabToolsPage() {
  const open = (t) => { window.open('/collab-view/' + t.key, '_blank', 'noopener'); };
  return (
    <AppShell app="collabtools" ownTabbarPad style={{ fontFamily: 'var(--gw-font)', background: 'var(--gw-bg, #fff)' }}>
      <div style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column' }}>
        <Announcements scope="collabtools" />
        <div className="gw-tabbar-pad" style={{ flex: 1, overflowY: 'auto' }}>
          <Page>
            <PageHeader icon={IconLayoutKanban} tone="blue" title="협업 도구" subtitle="사용할 도구를 선택하세요. 새 창으로 열립니다."
              actions={<Pill tone="gray" dot={false}>{COLLAB_TOOLS.length}개 도구</Pill>} />
            {/* 카드 묶음 폭 980 유지 · 머리와 같은 왼쪽 선 */}
            <div style={{ maxWidth: '980px' }}>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '12px' }}>
                {COLLAB_TOOLS.map((t) => {
                  const ToolIcon = TOOL_ICONS[t.key] || IconPuzzle;
                  return (
                  <button key={t.key} onClick={() => open(t)}
                    style={{ ...cardBase, background: 'var(--gw-surface, #fff)', minHeight: '150px', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '10px', padding: '18px',
                      cursor: 'pointer', textAlign: 'left', color: 'inherit' }}
                    onMouseEnter={(e) => { e.currentTarget.style.background = 'var(--gw-hover, #efefed)'; }}
                    onMouseLeave={(e) => { e.currentTarget.style.background = 'var(--gw-surface, #fff)'; }}>
                    {/* tabler 는 color 를 svg stroke 속성에 넣는다 → var() 는 style.color 로 주고 color 는 currentColor */}
                    <ToolIcon size={32} stroke={ICON_STROKE} color="currentColor" aria-hidden="true" style={{ color: 'var(--gw-secondary, #64635f)' }} />
                    <span style={{ fontSize: '14px', fontWeight: 620, color: 'var(--gw-text, #32312e)' }}>{t.label}</span>
                    <span style={{ fontSize: '13px', color: 'var(--gw-secondary, #64635f)', lineHeight: 1.55, wordBreak: 'keep-all' }}>{t.desc}</span>
                  </button>
                  );
                })}
              </div>
            </div>
          </Page>
        </div>
      </div>
    </AppShell>
  );
}
